import { useState } from 'react';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import Logger from 'forms-utils-lib/logger/Logger';

//@ts-expect-error missing types
import { deleteForms } from 'FormsUI/api/Forms';
import { usePopover } from 'FormsUI/components/dashboard/frameworkTable/OpenPopoverProvider';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import DeleteDialog from './DeleteDialog';
import DeleteButton from './DeleteButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteBulkAction = props => {
  const [loading, setLoading] = useState(false);
  const {
    showPopover,
    hidePopover
  } = usePopover();
  const deleteSelectedForms = () => {
    setLoading(true);
    const formIds = props.selectedObjects.map(crmObject => getPropertyValue(crmObject, PROPERTIES.FORM_ID));
    return deleteForms(formIds).then(() => {
      listingLibObserver.delete(props.selectedIds);
      props.onClearSelection();
    }).catch(error => {
      Logger.error(`Failed to delete forms with IDs: ${JSON.stringify(formIds)}`, error);
    }).finally(() => {
      setLoading(false);
      hidePopover();
    });
  };
  const Popover = /*#__PURE__*/_jsx(DeleteDialog, {
    handleConfirm: deleteSelectedForms,
    handleReject: hidePopover,
    selectedObjects: props.selectedObjects,
    disableConfirm: loading
  });
  return /*#__PURE__*/_jsx(DeleteButton, {
    onClick: () => showPopover(Popover),
    selectedObjects: props.selectedObjects
  });
};
export default DeleteBulkAction;